import React from 'react';
interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function Avatar({
  name,
  src,
  size = 'md'
}: AvatarProps) {
  const initials = name.split(' ').map(part => part[0]).join('').toUpperCase().substring(0, 2);
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };
  const classes = `${sizeClasses[size]} rounded-full flex items-center justify-center font-medium text-white bg-blue-600`;
  if (src) {
    return <img src={src} alt={name} className={`${sizeClasses[size]} rounded-full object-cover`} data-id="element-45" />;
  }
  return <div className={classes} data-id="element-46">{initials}</div>;
}